import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DspxBaseFormComponent } from 'dspx-core';
import { Form0408SubstanceService } from './form0408-substance.service';
import { FormCommonHelperService } from './formCommon.service';
import { FORM_04_PAGE_MAPPINGS, SCHEDULE_SECTION_TYPE } from './../constants/app-data.constants';

@Injectable({
  providedIn: 'root'
})
export class Form04HelperService {
  constructor(
    private formCommonHelperService: FormCommonHelperService,
    private form0408SubstanceService: Form0408SubstanceService
  ) { }

  // basicInfo functions ------------------------------------------------------------
  public isHsp(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4'];

      if (section == null) {
        return false;
      }

      result = (section?.['questione386aa9fca0b4c1c93ce7e138556c03f'] ?? false) === true;  // This form is being completed for an existing health service permit
    }

    return result;
  };

  public isNonHspPermit(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4'];

      if (section == null) {
        return false;
      }

      result = (section?.['question6dc878ddc19e4a7f839d46775530941e'] ?? false) === true;  // This form is being completed for an existing permit (25)
    }

    return result;
  };

  public isLicenceManufacturing(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionWhatsChanging = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['section2b39e8f7c8ba44299784bbe506983dc9'];
      const sectionLicencePermit = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4'];

      if (sectionWhatsChanging == null && sectionLicencePermit == null) {
        return false;
      }

      result = (
        (sectionWhatsChanging?.['question5212b6610f494df3aa07112dc14a5a78'] ?? false) === true  // Confirm that your organisation would like to change the licence to one that involves manufacturing activities
        ||
        (
          (
            (sectionLicencePermit?.['question481697904c1e4bf3bd4efa0ea7b5cbd4'] ?? false) === true  // This form is being completed for an existing licence to manufacture some substances from Schedules 8 and/or 9
            ||
            (sectionLicencePermit?.['question63a06ece250444f0a225e7352043490e'] ?? false) === true  // This form is being completed for an existing licence to manufacture some substances from Schedules 2, 3, 4 or 7 
          )
          &&
          (
            (sectionWhatsChanging?.['question4609388c64b8493f9f7a423331ccd30e'] ?? false) !== true  // Confirm that your organisation would like to change the licence to one that does not involve the possession or storage of scheduled substances by the licence holder, so that the licence holder only directs other organisations to supply. 
            &&
            (sectionWhatsChanging?.['question5c87e2408a604c1d8a910d5663a3a6f2'] ?? false) !== true  // Confirm that your organisation would like to cease manufacturing activities. 
          )
        )
      );
    }

    return result;
  };

  public isLicenceIndent(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionWhatsChanging = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['section2b39e8f7c8ba44299784bbe506983dc9'];
      const sectionLicencePermit = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4'];

      if (sectionWhatsChanging == null && sectionLicencePermit == null) {
        return false;
      }

      result = (
        (sectionWhatsChanging?.['question4609388c64b8493f9f7a423331ccd30e'] ?? false) === true  // Confirm that your organisation would like to change the licence to one that does not involve the possession or storage of scheduled substances by the licence holder, so that the licence holder only directs other organisations to supply. 
        ||
        (
          (
            (sectionLicencePermit?.['question63fa6b227a0e4469857dc1f0e1b221bd'] ?? false) === true  // This form is being completed for an existing licence to supply BY INDENT some substances from Schedules 8 and/or 9 
            ||
            (sectionLicencePermit?.['question574d77947c8f47eca620db47c6aab940'] ?? false) === true  // This form is being completed for an existing licence to supply BY INDENT some substances from Schedules 2, 3, 4 or 7 
          )
          &&
          (
            (sectionWhatsChanging?.['question209ef1b668ad471a98e851a9e5ac733b'] ?? false) !== true   // Confirm that your organisation would like to begin to possess and/or store the scheduled substances on the licence
            &&
            (sectionWhatsChanging?.['question5212b6610f494df3aa07112dc14a5a78'] ?? false) !== true  // Confirm that your organisation would like to change the licence to one that involves manufacturing activities 
          )
        )
      );
    }

    return result;
  };

  public isLicenceNonManufactNonIndent(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionWhatsChanging = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['section2b39e8f7c8ba44299784bbe506983dc9'];
      const sectionLicencePermit = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4'];

      if (sectionWhatsChanging == null && sectionLicencePermit == null) {
        return false;
      }

      result = (
        (
          (sectionWhatsChanging?.['question209ef1b668ad471a98e851a9e5ac733b'] ?? false) === true   // Confirm that your organisation would like to begin to possess and/or store the scheduled substances on the licence
          ||
          (sectionWhatsChanging?.['question5c87e2408a604c1d8a910d5663a3a6f2'] ?? false) === true  // Confirm that your organisation would like to cease manufacturing activities. 
          ||
          (
            (
              (sectionLicencePermit?.['question65536a6aba78454191b8376deead9280'] ?? false) === true  // This form is being completed for an existing licence to supply some substances from Schedules 8 and/or 9 
              ||
              (sectionLicencePermit?.['question998a380f6c0141188f00da8b9f2f0987'] ?? false) === true  // This form is being completed for an existing licence to supply some substances from Schedules 2, 3, 4 or 7 
            )
            &&
            (
              (sectionWhatsChanging?.['question4609388c64b8493f9f7a423331ccd30e'] ?? false) !== true  // Confirm that your organisation would like to change the licence to one that does not involve the possession or storage of scheduled substances by the licence holder, so that the licence holder only directs other organisations to supply. 
              &&
              (sectionWhatsChanging?.['question5212b6610f494df3aa07112dc14a5a78'] ?? false) !== true  // Confirm that your organisation would like to change the licence to one that involves manufacturing activities 
            )
          )
          ||
          (
            (sectionWhatsChanging?.['question5212b6610f494df3aa07112dc14a5a78'] ?? false) === true  // Confirm that your organisation would like to change the licence to one that involves manufacturing activities 
            &&
            this.isLicenceManufacturing(data) !== true
          )
          ||
          (
            (sectionWhatsChanging?.['question4609388c64b8493f9f7a423331ccd30e'] ?? false) === true  // Confirm that your organisation would like to change the licence to one that does not involve the possession or storage of scheduled substances by the licence holder, so that the licence holder only directs other organisations to supply. 
            &&
            this.isLicenceIndent(data) !== true
          )
          // This line ensures that "Licence (Non Manuf Non indent)" stays valid until "Licence, indent" is read, and therefore, the change made to indent is not cleared (and the line above this is similar, but for manufacturing)
        )
        &&
        (this.isLicenceManufacturing(data) !== true && this.isLicenceIndent(data) !== true)
      );
    }

    return result;
  };

  // Health Service Use -----------------------------------------------------------------
  public isHspDermalInjectables(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = false;
    }

    return result;
  };

  public isHspDermalInjectablesNothingElse(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = false;
    }

    return result;
  };

  public isVetHsp(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const animalHealthSection = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.healthServiceUses]?.['sectionfd43f7276b60437cbeadeb94d1e26c2b'];
      const animalResearchSection = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.uses]?.['sectione8d2c05b45814bceb918e70047c60b01'];
      const permitOnlyAnimalsSection = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.responsiblePerson]?.['sectionbb46215b12f54bb990d56ada5eabdd6a'];
      const healthPractitionerBasicsSection = data.form.tabs?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['page11']?.['section2be88ce2ed66424a8125eb3c6e114ca9'];

      if (animalHealthSection == null && animalResearchSection == null) {
        return false;
      }

      result = animalHealthSection?.['questionc2d0a8ac763b4a72af13e3502246831c'] === 'animal'  // Animal health services
        ||
        animalResearchSection?.['questione52dac1418814da88476f00d128ad80d'] === 'administer'  // Administration of substances to animals
        ||
        (permitOnlyAnimalsSection?.['question3451cbf4d6244e8f8093bf3e8706317e'] ?? false) === true // Veterinary Practitioners Registration Board of Victoria registration number
        ||
        (healthPractitionerBasicsSection?.['question6bfdc26c4a90454eb21ec4e30637de85'] ?? false) === true;  // Select here if the permit is used to ONLY provide ANIMAL health services
    }

    return result;
  };

  public isAgedCareHsp(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.healthServiceUses]?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = false;
    }

    return result;
  };

  public isHospitalHSP(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.healthServiceUses]?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = false;
    }

    return result;
  };


  public isSchedule2Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule2Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule3Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule3Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule4Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule4Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule4DDSubstance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule4DDSubstance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule7Substance(data: any) {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule7Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule7LRSubstance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule7LRSubstance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule8Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule8Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule9Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceHSP = scheduledSubstanceControls?.[0];
      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isSchedule9Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isCannabisAddition(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceNonHSPpermit = scheduledSubstanceControls?.[1];
      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isCannabisAddition(substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isNitrousAddition(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionType = data?.[2]?.trim(); // Is it an Add, Remove, or Holding
      const sectionIndex = +(data?.[1]?.trim());
      const scheduledSubstanceControls = this.getScheduledSubstanceControls(data, sectionType, sectionIndex);

      if (scheduledSubstanceControls == null) {
        return false;
      }

      const substanceLicence = scheduledSubstanceControls?.[2];

      result = this.form0408SubstanceService.isNitrousAddition(substanceLicence);
    }

    return result;
  }

  private getScheduledSubstanceControls(data: any, sectionType: string, sectionIndex: number): any {
    if (data?.[0]?.form?.tabs != null) {
      let section = null;

      switch (sectionType) {
        case SCHEDULE_SECTION_TYPE.add:
          section = data?.[0]?.form?.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section7148ac04a8694d7f9e2a94ba34a15153']?.[sectionIndex];
          return [
            section?.['questiona4a99c1e16a64936bb789451f0e0bf58']   // HSP
            , section?.['questionab57f5f95ff5466285af424bbef63ccc'] // NonHSPpermit
            , section?.['questioned448888578c463fa39a4795a1833150'] // Licence
          ];

        case SCHEDULE_SECTION_TYPE.remove:
          section = data?.[0]?.form?.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['sectione22c84a845654f81a377b90a9319fdbd']?.[sectionIndex];
          return [
            section?.['questionbac9ece2fb664f7d907ab49e776a347e']   // HSP
            , section?.['question6dac37431ba44684a6a00eda84eb038b'] // NonHSPpermit
            , section?.['question005bca481bf3489cbbf86bf979628326'] // Licence
          ];

        case SCHEDULE_SECTION_TYPE.holding:
          section = data?.[0]?.form?.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section155644b4da8f4b0e9936c235187e28ec']?.[sectionIndex];
          return [
            null   // HSP
            , section?.['question2be6a10196304e6181c3d55396720137'] // NonHSPpermit
            , null // Licence
          ];

        default:
          return null;
      }
    }

    return null;
  }

  private countOfScheduleSubstance(data: any, scheduledSubstanceFunction: (model: any[]) => boolean): number {
    let countOfScheduleSubstance: number = 0;

    if (data?.form?.tabs != null) {
      const repeatingSections = data?.form?.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section7148ac04a8694d7f9e2a94ba34a15153'];

      if (Array.isArray(repeatingSections)) {
        repeatingSections.forEach((section, index) => {
          let model: any[] = [data, index.toString(), SCHEDULE_SECTION_TYPE.add];
          let result = scheduledSubstanceFunction(model);
          if (result === true) {
            countOfScheduleSubstance++;
          }
        });
      }
    }

    return countOfScheduleSubstance;
  }

  private isAnyOfScheduleSubstanceType(data: any, changeAddSubstanceGroupControl: string, existingAddSubstanceGroupControl: string, changeRemoveSubstanceGroupControl: string, scheduledSubstanceFunction: (model: any[]) => boolean): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionChange = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section00be39c84d964435bcd234064532dae2'];       // change group section
      const sectionExisting = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.existingSubstances]?.['sectionc250b183d6e640c58d59cbd30fd68654'];     // exiting group section
      const sectionChangeRemove = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section90acceee752a42e8a875a75faf63fe8d']; // exiting group section

      result =
        (
          (sectionChange?.[changeAddSubstanceGroupControl] ?? false) === true
          ||
          (sectionExisting?.[existingAddSubstanceGroupControl] ?? false) === true
          ||
          this.countOfScheduleSubstance(data, (d) => scheduledSubstanceFunction(d)) > 0
        )
        &&
        // If they remove the entire schedule group then it overrides all other adds
        (sectionChangeRemove?.[changeRemoveSubstanceGroupControl] ?? false) !== true;
    }

    return result;
  }

  public isSchedule2SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data
        , 'question8765a4ed2c7245d1abaf9c70956b3119' // change substance - add group
        , 'question050ccfaee2c6460ea30a7a6147b5c685' // existing substance - add group
        , 'question7357d709bdd74b48bde689e7ceba07f0' // change substance - remove group
        , (d) => this.isSchedule2Substance(d));
    }

    return result;
  }

  public isSchedule3SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data
        , 'questionc13d2a78c92a48c68da8a0a6e967b781' // change substance - add group
        , 'question8a25fbcf109943f29de59b39e6f5eb9b' // existing substance - add group
        , 'questionb4842ac72f0642188ab78167efdb5c3b' // change substance - remove group
        , (d) => this.isSchedule3Substance(d));
    }

    return result;
  }

  public isSchedule4SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionChange = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section00be39c84d964435bcd234064532dae2'];
      const sectionExisting = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.existingSubstances]?.['sectionc250b183d6e640c58d59cbd30fd68654'];
      const sectionChangeRemove = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section90acceee752a42e8a875a75faf63fe8d'];

      result = (
        this.countOfScheduleSubstance(data, (d) => this.isSchedule4Substance(d)) > 0
        ||
        sectionChange?.['question72bfadd709dd43c7ae93bf5efea0d7a3'] === 'no' //change substance - schedule 4 - No
        ||
        (sectionExisting?.['question779834023c9b42a18d0ac43e15ee1ded'] ?? false) === true //existing substance - add group question
      )
      &&
      sectionChangeRemove?.['question28a7ca061e584ebd99ff17e9e3847a43'] !== 'no';
    }

    return result;
  }

  public isSchedule4DDSubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionChange = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section00be39c84d964435bcd234064532dae2'];
      const sectionExisting = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.existingSubstances]?.['sectionc250b183d6e640c58d59cbd30fd68654'];
      const sectionChangeRemove = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section90acceee752a42e8a875a75faf63fe8d'];

      result = (
        this.countOfScheduleSubstance(data, (d) => this.isSchedule4DDSubstance(d)) > 0
        ||
        sectionChange?.['question72bfadd709dd43c7ae93bf5efea0d7a3'] === 'yes' //change substance - schedule 4dd - Yes
        ||
        sectionExisting?.['question72bfadd709dd43c7ae93bf5efea0d7a3'] === 'no' //existing substance - schedule 4dd - No
      )
      &&
      (sectionChangeRemove?.['questiond4ba0d8ede164fedbff98cd2cbdcc82f'] ?? false) !== true;
    }

    return result;
  }

  public isSchedule7SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionChange = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section00be39c84d964435bcd234064532dae2'];
      const sectionExisting = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.existingSubstances]?.['sectionc250b183d6e640c58d59cbd30fd68654'];
      const sectionChangeRemove = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section90acceee752a42e8a875a75faf63fe8d'];

      result = (
        this.countOfScheduleSubstance(data, (d) => this.isSchedule7Substance(d)) > 0
        ||
        sectionChange?.['questionf7f9ec9a69c9486bbc741d820847ae20'] === 'no'
        ||
        (
          (this.isLicenceNonManufactNonIndent(data) === true || this.isLicenceManufacturing(data) || this.isLicenceIndent(data))
          &&
          (
            sectionExisting?.['questionaa6eda2d0826496dae7a0f209c8ec4e6'] === 'no'  // Are there any limitations on the range of Schedule 7 substances included on the licence?
            ||
            sectionExisting?.['question6e2b987a6db648fba74fc259a7b6c034'] === 'no'  // Note that these are all Schedule 7 substances that cannot be sold by retail, or “listed-regulated Schedule 7 substances”)
            ||
            sectionExisting?.['question2e0e51246a37402c8a2a6a70032f25bf'] === 'yes' // Aside from any of the substances listed above.
          )
        )
        &&
        sectionChangeRemove?.['questiona6de76630264452dbffbd1b11c43f4e2'] !== 'no'
      );
    }

    return result;
  }

  public isSchedule7LRSubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const sectionChange = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section00be39c84d964435bcd234064532dae2'];
      const sectionExisting = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.existingSubstances]?.['sectionc250b183d6e640c58d59cbd30fd68654'];
      const sectionChangeRemove = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section90acceee752a42e8a875a75faf63fe8d'];

      result = (
        this.countOfScheduleSubstance(data, (d) => this.isSchedule7LRSubstance(d)) > 0
        ||
        sectionChange['questionf7f9ec9a69c9486bbc741d820847ae20'] === 'yes' // Should the Schedule 7 substances include listed-regulated Schedule 7 substances?
        ||
        (
          this.isNonHspPermit(data)
          &&
          (
            (sectionChange?.['question36e45229305c4221ba279ae63e9671c0'] ?? false) === true    // change substance - add group
            ||
            (sectionExisting?.['questionc6d299590102463091134432df25950e'] ?? false) === true  // existing substance - add group
          )
        )
        ||
        (
          (this.isLicenceNonManufactNonIndent(data) || this.isLicenceManufacturing(data) || this.isLicenceIndent(data))
          &&
          (
            sectionExisting['questionaa6eda2d0826496dae7a0f209c8ec4e6'] === 'no' // Are there any limitations on the range of Schedule 7 substances included on the licence?
            ||
            sectionExisting['question6e2b987a6db648fba74fc259a7b6c034'] === 'yes' // (Note that these are all Schedule 7 substances that cannot be sold by retail, or “listed-regulated Schedule 7 substances”)
          )
        )
        &&
        sectionChangeRemove?.['questiona6de76630264452dbffbd1b11c43f4e2'] !== 'yes' // Within Schedule 7, should only listed-regulated Schedule 7 substances be removed from the licence/permit?
      );
    }

    return result;
  }

  public isSchedule8SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data
        , 'question5012208e2f90424b982fa29caf534de5' // change substance - add group
        , 'questionc1d46051adee4ab598dce85c2a080b3a' // existing substance - add group
        , 'question4e7e43179ac947adbbc9822f2a883d48' // change substance - remove group
        , (d) => this.isSchedule8Substance(d));
    }

    return result;
  }

  public isSchedule9SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data
        , 'questionf6c297b9c3fe43a78ee7fdd989691a77' // change substance - add group
        , 'question09dcbf0cf9cf4d16bcc8d1b85af2a7b3' // existing substance - add group
        , 'question307e5a9861f144d8b7b637ba08a32e0d' // change substance - remove group
        , (d) => this.isSchedule9Substance(d));
    }

    return result;
  }

  public isTherapeuticGoods(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = (
        (this.isLicenceNonManufactNonIndent(data) || this.isLicenceManufacturing(data) || this.isLicenceIndent(data))
        &&
        (this.isSchedule2SubstanceOrGroup(data) || this.isSchedule3SubstanceOrGroup(data) || this.isSchedule4SubstanceOrGroup(data) || this.isSchedule4DDSubstanceOrGroup(data) || this.isSchedule8SubstanceOrGroup(data) || this.isSchedule9SubstanceOrGroup(data))
        &&
        (
          data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.authorisedSupply]?.['section2063afeb93d44c8895f1f94389d7c2c4']?.['question3573cf08241a493aa7b2c0eae4677ade'] === 'yes'  // Would your organisation ever order the supply of any substances intended to be ultimately administered to a person by an end-user? (Any such items would be considered “therapeutic goods”)
          ||
          data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.manufacturing]?.['section0cceef95e5e74476ad8db48d8b118c4b']?.['question6707a0205a2b495ba83b38c73d3ce055'] === 'yes'  // Would your organisation produce any products intended to be administered to a person or an animal by an end-user?
        )
      );
    }

    return result
  }

  public nitrousAddition2(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isNitrousAddition(d)) > 0;
    }

    return result
  }

  public nitrousAlone(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['sectionb7c986556b89479bb7d82114f15eccad'];

      if (section == null) {
        return false;
      }

      result = (
        (this.nitrousAddition2(data) === true)
        &&
        (!(
          (this.countOfScheduleSubstance(data, (d) => this.isSchedule4Substance(d)) > 1)
          ||
          this.isSchedule4SubstanceOrGroup(data)
          ||
          this.isSchedule2SubstanceOrGroup(data)
          ||
          this.isSchedule3SubstanceOrGroup(data)
          ||
          this.isSchedule8SubstanceOrGroup(data)
        ))
      );
    }

    return result;
  }

  public nonHspWithAdmin(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isNonHspPermit(data)
        &&
        (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.uses]?.['sectione8d2c05b45814bceb918e70047c60b01']?.['question4eeb7fb8534644cebee8cda07c063426'] ?? false) === true;
    }

    return result;
  }


  public fee(data: any): number {
    if (data?.form?.tabs != null) {
      const _S89ManufactConfirm = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4']?.['question481697904c1e4bf3bd4efa0ea7b5cbd4'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/LicencePermitIdentif/_outerArea/_contentArea/Confirmation/ConfirmationOptions/S89ManufactConfirm"));
      const _S89SupplyConfirm = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4']?.['question65536a6aba78454191b8376deead9280'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/LicencePermitIdentif/_outerArea/_contentArea/Confirmation/ConfirmationOptions/S89SupplyConfirm"));
      const _S2347ManufactConfirm = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4']?.['question63a06ece250444f0a225e7352043490e'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/LicencePermitIdentif/_outerArea/_contentArea/Confirmation/ConfirmationOptions/S2347ManufactConfirm"));
      const _S2347SupplyConfirm = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4']?.['question63a06ece250444f0a225e7352043490e'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/LicencePermitIdentif/_outerArea/_contentArea/Confirmation/ConfirmationOptions/S2347SupplyConfirm"));
      const _ChangePhysicalPremis = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.Address]?.['section33417013270c471094e0dea2903d3c3d']?.['questionac81d3a04c734b4f9f5b2cc443060234'] ?? '') === 'physical';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../Address/_outerArea/_contentArea/AddressChangeOptions/_outerArea/_contentArea/IsItIntendedThatSche/_layoutBlock/ChangePhysicalPremis"));
      const _ChangeBothPhysicalPr = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.Address]?.['section33417013270c471094e0dea2903d3c3d']?.['questionac81d3a04c734b4f9f5b2cc443060234'] ?? '') === 'both';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../Address/_outerArea/_contentArea/AddressChangeOptions/_outerArea/_contentArea/IsItIntendedThatSche/_layoutBlock/ChangeBothPhysicalPr"));
      const _ChangeFROMindent = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['section2b39e8f7c8ba44299784bbe506983dc9']?.['question209ef1b668ad471a98e851a9e5ac733b'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/WhatIsChangingifAnyt/_outerArea/_contentArea/ChangeOptions/DirectSupplyChangeBk/ChangeFROMindent"));
      const _S89IndentSupplyConfm = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4']?.['question63fa6b227a0e4469857dc1f0e1b221bd'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/LicencePermitIdentif/_outerArea/_contentArea/Confirmation/ConfirmationOptions/S89IndentSupplyConfm"));
      const _S2347IndentSupplyCon = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.basicInfo]?.['sectionc2e2371f7d2e4ec7bdf849848cebffa4']?.['question574d77947c8f47eca620db47c6aab940'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/LicencePermitIdentif/_outerArea/_contentArea/Confirmation/ConfirmationOptions/S2347IndentSupplyCon"));
      const _ADDNewSubstancesToTh = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section8025082cb72c4ad9b52c7153033b1db1']?.['question0b8a927461ba49559a31b13ba09fa169'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/AdditionalSiteDetail/_outerArea/_contentArea/IsItIntendedThatSche/AddSitechangeBlock/ADDNewSubstancesToTh"));
      const _ChangeMaximumHolding = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section8025082cb72c4ad9b52c7153033b1db1']?.['questionb96f65eccc854fc988350e621887044b'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/AdditionalSiteDetail/_outerArea/_contentArea/IsItIntendedThatSche/AddSitechangeBlock/ChangeMaximumHolding"));
      const _MakeChangesToThePRIN = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.Address]?.['question5f04e775aef4435194dd11223588a99c']?.['sectionc5fbaa2e32094214b68a1ed4ffcad0bc'] ?? '') === 'principleOnly';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../Address/_outerArea/_contentArea/AdditionalSites/_outerArea/_contentArea/IsItIntendedThatSche/_layoutBlock/MakeChangesToThePRIN"));
      const _ChangeBOTHThePrincip = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.Address]?.['questiond214ac221bc94cb3b03cb3542a5f0c81']?.['sectionc5fbaa2e32094214b68a1ed4ffcad0bc'] ?? '') === 'both';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../Address/_outerArea/_contentArea/AdditionalSites/_outerArea/_contentArea/IsItIntendedThatSche/_layoutBlock/IsThePharmacyOperate/_layoutBlock/ChangeBOTHThePrincip"));
      const _BOTHTheOwnershiplega = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.nameOrOwnership]?.['sectionaffe2e7d3e824764834a8c8c941e9fd2']?.['questioncef6c141df4849cda423797570ef8e66'] ?? '') === 'both';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../NameOrOwnership/_outerArea/_contentArea/AddressChangeOptions/_outerArea/_contentArea/IsItIntendedThatSche/_layoutBlock/BOTHTheOwnershiplega"));
      const _TheOwnershipOnlyieTh = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.nameOrOwnership]?.['sectionaffe2e7d3e824764834a8c8c941e9fd2']?.['questioncef6c141df4849cda423797570ef8e66'] ?? '') === 'ownershipOnly';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../NameOrOwnership/_outerArea/_contentArea/AddressChangeOptions/_outerArea/_contentArea/IsItIntendedThatSche/_layoutBlock/TheOwnershipOnlyieTh"));
      const _HSP = this.isHsp(data);  //sfc.convertToFloat(sfc.getRawValue(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/HSP")));
      const _n31To100 = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.uses]?.['sectionb88b6b8a01a94657b783520cd358ef28']?.['question8c76bd83b75b493ca4e48f133813c945'] ?? '') === '31';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../IncidentDetails/_outerArea/_contentArea/PatientBeds/_outerArea/_contentArea/NumberOfBeds/_layoutBlock/n31To100"));
      const _MoreThan100 = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.uses]?.['sectionb88b6b8a01a94657b783520cd358ef28']?.['question8c76bd83b75b493ca4e48f133813c945'] ?? '') === 'more';  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../IncidentDetails/_outerArea/_contentArea/PatientBeds/_outerArea/_contentArea/NumberOfBeds/_layoutBlock/MoreThan100"));
      const _ADDNewSitesToThePerm = false;// sfc.isButtonSelected(sfc.normalizeUid(me, "../../AdditionalSites/_outerArea/_contentArea/AdditionalSiteDetail/_outerArea/_contentArea/IsItIntendedThatSche/AddSitechangeBlock/ADDNewSitesToThePerm"));
      const _YesThereAreAdditiona = false;// sfc.isButtonSelected(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/PossibleMultipleSite/_outerArea/_contentArea/WouldYourOrganisatio/_layoutBlock/YesThereAreAdditiona"));
      const _NonHSPPermit = this.isNonHspPermit(data);  // sfc.convertToFloat(sfc.getRawValue(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/NonHSPPermit")));
      const _S8identity = this.isSchedule8SubstanceOrGroup(data); //sfc.convertToFloat(sfc.getRawValue(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/S8identity")));
      const _S9 = this.isSchedule9SubstanceOrGroup(data);  //sfc.convertToFloat(sfc.getRawValue(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/S9")));
      const _LicenceIndent = this.isLicenceIndent(data); //sfc.convertToFloat(sfc.getRawValue(sfc.normalizeUid(me, "../../GettingStarted/_outerArea/_contentArea/LicenceIndent")));
      const _Schedule8Substances = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section00be39c84d964435bcd234064532dae2']?.['question5012208e2f90424b982fa29caf534de5'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/AddingSubstances/AddWholeGroupsOfSubs/_outerArea/_contentArea/SelectGroupsOfSubsta/Schedule8Substances"));
      const _Schedule9Substances = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section00be39c84d964435bcd234064532dae2']?.['questionf6c297b9c3fe43a78ee7fdd989691a77'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/AddingSubstances/AddWholeGroupsOfSubs/_outerArea/_contentArea/SelectGroupsOfSubsta/Schedule9Substances"));
      const _S8addition = this.countOfScheduleSubstance(data, (d) => this.isSchedule8Substance(d)) > 0;  // sfc.convertToRawValueArray(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/AddingSubstances/AddIndividualSubstan/_outerArea/_contentArea/IndividualSubstBelow/IndividualSubstances/IndividualSubstancesTable/row[*]/S8addition"));
      const _S9addition = this.countOfScheduleSubstance(data, (d) => this.isSchedule9Substance(d)) > 0;  // sfc.convertToRawValueArray(sfc.normalizeUid(me, "../../SubstanceChanges/_outerArea/_contentArea/AddingSubstances/AddIndividualSubstan/_outerArea/_contentArea/IndividualSubstBelow/IndividualSubstances/IndividualSubstancesTable/row[*]/S9addition"));
      const _Schedule8Substances1 = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.existingSubstances]?.['sectionc250b183d6e640c58d59cbd30fd68654']?.['questionc1d46051adee4ab598dce85c2a080b3a'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../ExistingSubstances/_outerArea/_contentArea/WhatSubstancesAreCur/_outerArea/_contentArea/SelectGroupsOfSubsta/Schedule8Substances"));
      const _Schedule9Substances1 = (data.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.existingSubstances]?.['sectionc250b183d6e640c58d59cbd30fd68654']?.['question09dcbf0cf9cf4d16bcc8d1b85af2a7b3'] ?? false) === true;  //sfc.isButtonSelected(sfc.normalizeUid(me, "../../ExistingSubstances/_outerArea/_contentArea/WhatSubstancesAreCur/_outerArea/_contentArea/SelectGroupsOfSubsta/Schedule9Substances"));
      if (
        ((_MakeChangesToThePRIN || _ChangeBOTHThePrincip) || (_BOTHTheOwnershiplega || _TheOwnershipOnlyieTh))
        && _HSP
        && (!(_n31To100 || _MoreThan100))
        && (!_ADDNewSitesToThePerm)
        && (!_YesThereAreAdditiona)
      ) {
        return 1094.20;
      } // HSP Type A or B

      if (
        ((_MakeChangesToThePRIN || _ChangeBOTHThePrincip) || (_BOTHTheOwnershiplega || _TheOwnershipOnlyieTh))
        && _HSP
      ) {
        return 1420.30;
      } // HSP Type C or D

      if (
        ((_MakeChangesToThePRIN || _ChangeBOTHThePrincip) || (_BOTHTheOwnershiplega || _TheOwnershipOnlyieTh))
        && _NonHSPPermit && (_S8identity || _S9)
      ) {
        return 1420.30;
      } // Non-HSP permit with S8or9s

      if (
        ((_MakeChangesToThePRIN || _ChangeBOTHThePrincip) || (_BOTHTheOwnershiplega || _TheOwnershipOnlyieTh))
        && _NonHSPPermit
      ) {
        return 1256.50;
      } // Non-HSP permit without S8or9s

      if (
        ((_ChangePhysicalPremis || _ChangeBothPhysicalPr) || (_BOTHTheOwnershiplega || _TheOwnershipOnlyieTh))
        && (_S89ManufactConfirm || _S89SupplyConfirm)
      ) {
        return 1420.30;
      } // Non-indent licence with S8/9s

      if (
        ((_ChangePhysicalPremis || _ChangeBothPhysicalPr) || (_BOTHTheOwnershiplega || _TheOwnershipOnlyieTh))
        && (_S2347ManufactConfirm || _S2347SupplyConfirm)
      ) {
        return 1256.50;
      } // Non-indent licence without S8/9s

      if (
        (_ChangePhysicalPremis || _ChangeBothPhysicalPr)
        && _LicenceIndent
      ) {
        return 204.40;
      } // Indent licence change of premises

      if ((_BOTHTheOwnershiplega || _TheOwnershipOnlyieTh)
        && _LicenceIndent
      ) {
        return 1094.20;
      } // Indent licence change of legal entity

      if (_ChangeFROMindent && _S89IndentSupplyConfm) {
        return 1420.30;
      }

      if (_ChangeFROMindent && _S2347IndentSupplyCon) {
        return 1256.50;
      }

      if (_NonHSPPermit && (_Schedule8Substances || _Schedule9Substances || _S8addition || _S9addition) && (!(_Schedule8Substances1 || _Schedule9Substances1))) {
        return 1420.30;
      }

      if (_ADDNewSubstancesToTh || _ChangeMaximumHolding) {
        return 204.40;
      }
    }

    return 0
  }

  public hasFee(data: any): boolean {
    if (data?.form?.tabs != null) {
      const fee = this.fee(data) ?? 0;

      return fee > 0;
    }

    return false
  }

  public calculateFee(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {
      const fee = (this.fee(baseForm.model) ?? 0).toString();
      const feeControl = (baseForm.form as FormGroup).get(`form.tabs.tab1.${FORM_04_PAGE_MAPPINGS.submit}.sectiona6ad1d1acb7b4cb0a70c07de23fc89d5.question065799a9c77440d9ab99dedb00eae4d4`);
      if (feeControl.value !== fee) {
        feeControl.patchValue(fee);
        feeControl.markAsPristine();
        feeControl.markAsUntouched();
      }
    }
  }

  public calculateYearsExperience(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {
      const pageArray = baseForm.model.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.responsiblePerson];
      if (!Array.isArray(pageArray)) {
        return;
      }

      pageArray.forEach((currentPage, index) => {
        let pageTotalYearsInRole = 0;
        currentPage?.['section6419fa615a4b49788be088211374a1c3']?.forEach(currentSection => {
          const yearsInRole = currentSection?.['question4ebf21ef2a1846d08efaa814bbb45185']
          if (!isNaN(yearsInRole) && !isNaN(parseFloat(yearsInRole))) {
            pageTotalYearsInRole += +yearsInRole;
          }
        });
        const totalYearsControl = (baseForm.form as FormGroup).get(`form.tabs.tab1.${FORM_04_PAGE_MAPPINGS.responsiblePerson}.${index}.section577f17b96244425a991cc43d38426a7a.questionce8aa73326064747bfb745cf5a70ac8a`);
        if (totalYearsControl && totalYearsControl.value !== pageTotalYearsInRole) {
          totalYearsControl.patchValue(pageTotalYearsInRole);
          totalYearsControl.markAsPristine();
          totalYearsControl.markAsUntouched();
        }
      });
    }
  }

  public anyIndividualSubstance8(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isSchedule8Substance(d)) > 0;
    }

    return result;
  }

  public anyIndividualSubstance9(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isSchedule9Substance(d)) > 0;
    }

    return result;
  }

  public anyIndividualSubstanceCannabis(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isCannabisAddition(d)) > 0;
    }

    return result;
  }

  public calculateTotalMilligrams(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {

      const section = baseForm.model.form.tabs?.['tab1']?.[FORM_04_PAGE_MAPPINGS.substanceChanges]?.['section7148ac04a8694d7f9e2a94ba34a15153'];
      if (section == null) {
        return;
      }

      let totalMilligrams = 0;
      section?.forEach(currentSection => {
        const milligrams = currentSection?.['question7ef472bed5f04467aca6c34f92ec07c6']
        if (!isNaN(milligrams) && !isNaN(parseFloat(milligrams))) {
          totalMilligrams += +milligrams;
        }
      });
      const totalMilligramsControl = (baseForm.form as FormGroup).get(`form.tabs.tab1.${FORM_04_PAGE_MAPPINGS.substanceChanges}.section5ec0e0a10cfc4dc6b4f6c7c05b908f15.question1ab699ee818947a7843c3579c672422e`);
      if (totalMilligramsControl && totalMilligramsControl.value !== totalMilligrams) {
        totalMilligramsControl.patchValue(totalMilligrams);
        totalMilligramsControl.markAsPristine();
        totalMilligramsControl.markAsUntouched();
      }
    }
  }


}
